$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
     return null;
  }
  return decodeURI(results[1]) || 0;
}

var baseDomain = window.partner.baseDomain;
var apiToken = getCookie('api_token');

var http = {
  baseUrl: [baseDomain, 'apps/api'].join('/'),
  sendReq: function(url, method, content) {
    var reqOpt = {
          type: method,
          url: [this.baseUrl, url].join('/'),
          headers: {
            'x-api-key': apiToken,
            'issuer': window.partner.storeId,
            'Accept-Language': 'vi-VN'
          },
          contentType: 'application/json; charset=utf-8',
          dataType: 'json'
      };

      if (method.toLowerCase() !== 'get')
          reqOpt['data'] = JSON.stringify(content);

      var def = $.Deferred();
      $.ajax(reqOpt).done(function (res) {
          def.resolve(res);
      }).fail(function (ex) {
          console.log(ex);
      }).always(function () {
      });

      return def.promise();
  },
  get: function (url) {
      console.log(url);
      return this.sendReq(url, 'get');
  },
  post: function (url, content) {
      return this.sendReq(url, 'post', content);
  },
  put: function (url, content) {
      return this.sendReq(url, 'put', content);
  },
  delete: function (url, content) {
      return this.sendReq(url, 'delete', content);
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');

  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, expiration, typeEx) {
  const d = new Date()
  if (typeEx === 'second') {
    d.setTime(expiration * 1000);
  } else if (typeEx === 'day') {
    d.setTime(d.getTime() + (expiration * 24 * 60 * 60 * 1000));
  }
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getOMSAccessToken() {
  const omsAccessTocken = getCookie('oms_access_token');

  if(!omsAccessTocken) {
    return http.get('partner/oms-token')
      .then((res) => {
        if(!res) return Promise.reject(new Error("Cannot get access token"));

        setCookie('oms_access_token', res.access_token, (res.expires_in - 600)/60/60/24, 'day');

        return res.access_token;
      });
      // .fail((err) => {
      //   return Promise.reject(err);
      // });
  }
  else {
    return Promise.resolve(omsAccessTocken);
  }
}

// Get API Token
async function getAPIToken() {
  if (!apiToken) {
    try {
      const response = await $.ajax({
        method: 'GET',
        url: `${window.partner.baseDomain}/apps/api/authen/api-token`,
        headers: {
          'issuer': window.partner.storeId,
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
      });

      apiToken = response.token;
      setCookie('api_token', apiToken, response.expired - 600, 'second');

      return apiToken;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

async function callAPIWithTokenRefresh (url, method, content) {
  try {
    if (!getCookie('api_token')) {
      await getAPIToken();
    }

    const response = await http.sendReq(url, method, content);
    return response;
  } catch (ex) {
    if (ex.status === 401) {
      // Token expired, refresh the token
      try {
        await getAPIToken();
        // Retry the API call with the new token
        return await http.sendReq(url, method, content);
      } catch (err) {
        console.log(err);
        throw err; // Token refresh failed
      }
    } else {
      console.log(ex);
      throw ex; // Other API call failure
    }
  }
}

getAPIToken();

getOMSAccessToken();

window.getOMSAccessToken = getOMSAccessToken;
